import { SxProps, Theme, styled } from "@mui/material";
import type { FC } from "react";
import MedialHealthLogo from "../icons/MedialHealthLogo-500.png";

interface LogoProps {
  sx?: SxProps<Theme>;
}

const Logo: FC<LogoProps> = (props) => (
  <img
    src={MedialHealthLogo}
    title="Medial Health Logo"
    className="logo"
    height="52px"
    width="52px"
    alt="Medial Health Logo"
  />
);

export default Logo;
